// import env from '@/utils/env';
import cookie from '@/utils/cookie';
import storage from '@/utils/storage';
// import InitCKBusiness from '@hb/ckbusiness';
import getSearchObj from '@/utils/getSearchObj';
// import wechat from '@/utils/platformUtils/wechat';

const TOKEN_KEY = 'user_token';
const TICKET_KEY = 'user_ticket';

export default {

  // get business() {
  //   return new InitCKBusiness(6, false);
  // },

  init() {
    const { token, ticket } = getSearchObj();
    if (token && ticket) {
      this.setToken(token);
      this.setTicket(ticket);
    } else if (token) {
      this.setToken(token);
      this.clearTicket();
    }
  },

  // get domain() {
  //   return this.business.getDomain();
  // },

  // get wxPublicId() {
  //   return this.business.getAppId();
  // },

  get token() {
    return storage.getItem(TOKEN_KEY) || cookie.getItem(TOKEN_KEY);
  },

  get ticket() {
    return storage.getItem(TICKET_KEY) || cookie.getItem(TICKET_KEY);
  },

  setToken(val) {
    storage.setItem(TOKEN_KEY, val);
    cookie.setItem(TOKEN_KEY, val);
  },

  setTicket(val) {
    storage.setItem(TICKET_KEY, val);
    cookie.setItem(TICKET_KEY, val);
  },

  clearToken() {
    storage.removeItem(TOKEN_KEY);
    cookie.removeItem(TOKEN_KEY);
  },

  clearTicket() {
    storage.removeItem(TICKET_KEY);
    cookie.removeItem(TICKET_KEY);
  },

  reset() {
    this.clearToken();
    this.clearTicket();
  },
};
